<md-content-box class="enrollment-box">
	<div class="enrollment-info">
		<div class="enrollment-info__header">
			<div class="enrollment-info__title">
				<div class="enrollment-name">
					<md-header (click)="openLink('enrollment'); $event.stopPropagation()" size="sm" variant="semibold" [ngClass]="{ clickable: isUserAdmin() }">
						<!-- <md-icon icon="untitled-ui/general/translate-01"></md-icon> -->
						{{ languageName() }}
					</md-header>
					<md-header size="xs" variant="medium">{{ enrollment().languageLevels }}</md-header>
				</div>
				<div class="program-info">
					@if (enrollment().programTypeName) {
						<lb-program-type-tag
							variant="modern"
							[showFullName]="true"
							[program]="enrollment().programName"
							[programType]="enrollment().programTypeName"
						></lb-program-type-tag>
					}
					<lb-enrollment-tag
						[enrollmentStatus]="enrollment().enrollmentStatusName"
						[enrollmentStatusID]="enrollment().enrollmentStatusID"
						[isLearner]="userView() === 'learner'"
					></lb-enrollment-tag>
				</div>
			</div>
			<span class="spacer"></span>
			<div (click)="$event.stopPropagation()">
				<ng-content select="[enrollment-links]"></ng-content>
			</div>
			@if (isScheduleCTA()) {
				<button md-button-brand (click)="onCardClick()">Schedule Lessons</button>
			} @else if (enableLessonDetails()) {
				<button md-button (click)="onCardClick()">View Details</button>
			}
		</div>
		<div class="program-info">
			<div class="program-info__content">
				@if (userView() === 'instructor') {
					@if (enrollment().instructorUserID && enrollment().enrollmentStatusID !== 3) {
						<div class="instructor-avatar" (click)="openLink('instructor'); $event.stopPropagation()" [ngClass]="{ clickable: isUserAdmin() }">
							<lb-user-icon [userID]="enrollment().instructorUserID"></lb-user-icon>
							<div class="user-info">
								<div class="name">
									<span class="user-info__top">
										{{ instructor()?.fullName }}
									</span>
									<md-tag type="tertiary">Instructor</md-tag>
								</div>
								<div>
									@if (instructor()?.username; as instructorEmail) {
										{{ instructorEmail }}
										<lb-copy-to-clipboard [textToCopy]="instructorEmail" [showConfirmation]="true"></lb-copy-to-clipboard>
									}
								</div>
							</div>
						</div>
					} @else {
						<lb-no-instructor />
					}
				} @else {
					<div class="instructor-avatar" (click)="openLink('learner'); $event.stopPropagation()" [ngClass]="{ clickable: isUserAdmin() }">
						<lb-user-icon [userID]="enrollment().learnerUserID"></lb-user-icon>
						<div class="user-info">
							<div class="name">
								<span class="user-info__top">{{ learner()?.fullName }}</span>
								<md-tag type="tertiary">Learner</md-tag>
								@for (tag of learnerTags(); track tag.userTagTypeID) {
									<md-tag [type]="tag.tagColor ?? 'warning'">{{ tag.tagTypeName }}</md-tag>
								}
							</div>

							@if (learner()?.username; as learnerEmail) {
								@if (!learnerEmail.includes('@cr.languagebird.com')) {
									<div>
										{{ learnerEmail }}
										<lb-copy-to-clipboard [textToCopy]="learnerEmail" [showConfirmation]="true"></lb-copy-to-clipboard>
									</div>
								}
							}
						</div>
					</div>
				}
				@if (relatedInstitution()) {
					<div class="institution-info">
						<span>Institution</span>
						<md-tag type="warning">{{ relatedInstitution() }}</md-tag>
					</div>
				}
			</div>
		</div>
		<div class="status-info">
			<div class="status-info__content">
				<div>
					<span>Lesson Times</span>
					@if (timeSlotSelections().length > 0) {
						<div class="chip-container">
							@for (selection of timeSlotSelections(); track $index) {
								<div class="schedule">
									<md-content-box>{{ selection.day.substring(0, 3) }}, {{ selection.displayValue }}</md-content-box>
								</div>
							}
						</div>
					} @else {
						<span class="status-info__placeholder">N/A</span>
					}
				</div>
			</div>
			<button
				type="button"
				class="status-info__toggle"
				(click)="toggleDetails(); $event.stopPropagation()"
				[attr.aria-expanded]="detailsExpanded()"
				[attr.aria-controls]="isUserInstructor() ? 'enrollmentDetailsBody' : null"
				[attr.aria-label]="detailsExpanded() ? 'Hide enrollment details' : 'Show enrollment details'"
			>
				<md-icon [ngClass]="{ rotated: detailsExpanded() }" icon="untitled-ui/arrows/chevron-down"></md-icon>
			</button>
		</div>

		@if (detailsExpanded()) {
			<div class="details-section">
				<div class="schedule-info">
					@if (showMustStartBy()) {
						<div>
							<span>Must Start By</span>
							<span>{{ enrollment().mustStartBy | date: 'd MMM yyyy' }}</span>
						</div>
					}
					@if (showStartDate()) {
						<div>
							<span>{{ startDateLabel() }}</span>
							<span>{{ startDate() }}</span>
							@if (startDateToBeConfirmed()) {
								<md-tag type="tertiary">Pending Start</md-tag>
							}
						</div>
					}
					@if (showLastLessonDate()) {
						<div>
							<span>{{ endDateLabel() }}</span>
							<span>{{ endDate() }}</span>
						</div>
					}
					@if (showEnrollmentExpiration()) {
						<div>
							<span>Enrollment Expiration</span>
							<span>{{ enrollment().programExpirationDate | date: 'd MMM yyyy' }}</span>
						</div>
					}
				</div>
			</div>

			<div class="details-section">
				<div class="schedule-info">
					@if (showLessonFrequency()) {
						<div>
							<span>Lesson Frequency</span>
							@if (enrollment().lessonFrequency) {
								<span>{{ enrollment().lessonFrequency }} lessons / week</span>
							} @else {
								<span>-</span>
							}
						</div>
					}
					<div>
						<span>Time Zone</span>
						<span>{{ timeZoneName() || '-' }}</span>
					</div>
					@if (finalGrades().length) {
						<div>
							<span>Final Grades</span>
							<div class="grade-container">
								@for (grade of finalGrades(); track grade.semesterID) {
									<span>{{ grade.levelName }}</span>
									<lb-grade-tag [compact]="true" [grade]="grade.gradeName" [categoryName]="grade.levelName"></lb-grade-tag>
								}
							</div>
						</div>
					}
				</div>
			</div>

			@if (isUserInstructor()) {
				<div class="details-section">
					<div id="enrollmentDetailsBody" class="details-section__body">
						<div class="enrollment-notes">
							<div>
								<span>Learning Needs</span>
								<span>{{ learningNeeds() ? learningNeeds().note : '-' }}</span>
							</div>
							<div>
								<span>Language Experience</span>
								<span>{{ languageExperience() ? languageExperience().note : '-' }}</span>
							</div>
						</div>
					</div>
				</div>
			}
		}

		@if (programSummary(); as programSummary) {
			<lb-program-completion-summary [program]="programSummary"> </lb-program-completion-summary>
		}
	</div>
</md-content-box>
